import styled from 'foundations-theming/utils';
import { trellisBreakpoint } from 'pricing-pages-ui-components/constants/Breakpoints';
import { useEffect, useRef } from 'react';
import { STARTER } from 'self-service-api/constants/ProductLevels';
import { fetchPerProductPricingApiCompleted, fetchPerProductPricingApiFailed, fetchPerProductPricingApiStarted, planBuilderInitializationComplete } from '../../actions/PlanBuilderActions';
import { useGlobalLoading } from '../../hooks/loadingHooks';
import { useCountryCode } from '../../hooks/useCurrencies';
import { usePlanBuilderPurchaseOptions } from '../../hooks/usePurchaseOptions';
import { useAppDispatch, useAppSelector } from '../../reducers';
import { suiteProductConfigurationsSelector } from '../../selectors/ProductConfigsSelectors';
import { useQueryParamProductConfigsOrDefault } from '../../utils/planBuilderUtils/PlanBuilderQueryParamUtils';
import { useQueryParamTerm } from '../../utils/urls/appQueryParamUtilsLegacy';
import { jsx as _jsx } from "react/jsx-runtime";
const ResponsiveFlex = styled.div.withConfig({
  displayName: "PlanBuilderContent__ResponsiveFlex"
})(({
  theme
}) => {
  return {
    inlineSize: '100%',
    display: 'flex',
    flexDirection: 'row',
    [trellisBreakpoint.cs]: {
      flexDirection: 'column',
      alignItems: 'center',
      paddingInline: theme.space[300]
    }
  };
});
const PlanBuilderContent = ({
  children
}) => {
  const dispatch = useAppDispatch();
  const hasInitialized = useRef(false);
  const isAppReady = useGlobalLoading();
  const countryCode = useCountryCode();

  // Default to Starter CP
  const defaultProductConfigurations = useAppSelector(state => {
    if (!isAppReady) {
      return [];
    }
    return suiteProductConfigurationsSelector(state, {
      productLevel: STARTER
    });
  });

  // Get the product configurations from the query params if present otherwise use the default
  const initialProductConfigurationsUsingQueryParams = useQueryParamProductConfigsOrDefault({
    defaultConfigurations: defaultProductConfigurations
  });
  const {
    queryParamTerm
  } = useQueryParamTerm();
  useEffect(() => {
    if (!isAppReady || hasInitialized.current || !initialProductConfigurationsUsingQueryParams.length) {
      return;
    }
    hasInitialized.current = true;
    dispatch(planBuilderInitializationComplete({
      productConfigurations: initialProductConfigurationsUsingQueryParams,
      countryCode
    }));
  }, [isAppReady, initialProductConfigurationsUsingQueryParams, countryCode, dispatch]);

  // fetch per-product pricing, cache, and dispatch fetch actions
  const {
    loading: popPricingLoading
  } = usePlanBuilderPurchaseOptions({
    term: queryParamTerm,
    onCompleted: ({
      pricingData,
      hasCommonTerms
    }) => {
      dispatch(fetchPerProductPricingApiCompleted({
        pricingData,
        hasCommonTerms: hasCommonTerms !== null && hasCommonTerms !== void 0 ? hasCommonTerms : false
      }));
    },
    onError: () => {
      dispatch(fetchPerProductPricingApiFailed());
    }
  });
  useEffect(() => {
    // Triggering based on `loading` since DFC doesn't have an onLoading callback
    // the onCompleted and onError callbacks will clear this loading state
    if (popPricingLoading) {
      dispatch(fetchPerProductPricingApiStarted());
    }
  }, [popPricingLoading, dispatch]);
  return /*#__PURE__*/_jsx(ResponsiveFlex, {
    children: children
  });
};
export default PlanBuilderContent;